import React from 'react';
import getBlogCards from '../../api/getBlogCards';
import BlogCard from '../../components/blogCard/BlogCard';
import BlogFun from '../../components/blogFunc/BlogFunc';
import './Blog.css';

export default class Blog extends React.Component {
  state = {
    blogCardsInfo: [],
    numberOfBlogs:0
  }

  async setBlogCards() {
    const blogsInfo = await getBlogCards();

    if(blogsInfo != null && blogsInfo.status === 200) {
        this.setState({
        blogCardsInfo: blogsInfo.blogs,
        numberOfBlogs: blogsInfo.blogs.length
      });
    }
  }

  handleUpdateBlogs = (blogsInfo) => {
    if(blogsInfo.status === 200)
      this.setState({
        blogCardsInfo:blogsInfo.blogs
      })
    else
      this.setState({blogCardsInfo:[]})
  }

  componentDidMount() {
    this.setBlogCards();
  }

  render() {
    return (
      <section className="blog">
        <BlogFun
          handleUpdateBlogs={this.handleUpdateBlogs}
          numberOfBlogs={this.state.numberOfBlogs}
        />

        <div className="blogs-container">
          {
            this.state.numberOfBlogs > 0 
            ?this.state.blogCardsInfo.map(blog => {    
              return (
                <BlogCard
                  key={blog.id}
                  title={blog.title}
                  description={blog.description}
                  img={blog.imgUrl}
                  link={'/blogs/'+blog.id}
                />
              )
            })
            :""
          }
        </div>
      </section>
    )
  }
}